export const HealthPage = () => {
  return (
    <>
      <div>
        <h1>Health is good!</h1>
      </div>
    </>
  );
};
